
import { Hero } from "@/components/Hero";
import { AdvantagesList } from "@/components/AdvantagesList";
import { CoachCarousel } from "@/components/CoachCarousel";
import { ReviewsSection } from "@/components/ReviewsSection";
import { FAQSection } from "@/components/FAQSection";
import { StatisticsSection } from "@/components/StatisticsSection";

const Index = () => {
  return (
    <div className="pt-24">
      <Hero />
      <CoachCarousel />
      <StatisticsSection />
      <ReviewsSection />
      <AdvantagesList />
      <FAQSection />
    </div>
  );
};

export default Index;
